import React from 'react'
import { Card, CardBody, CardHeader, CardTitle, Button } from 'reactstrap'

const RegistrationSuccessful = () => {
  return (
    <div style={{
      background: 'linear-gradient(135deg, #ce9558 0%, #b8844a 60%, #ffff 100%)',
      minHeight: '100vh'
    }} className='d-flex justify-content-center align-items-center'>
      <div className='container-fluid px-3'>
        <div className='row justify-content-center'>
          <div className='col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5'>
            <Card className='shadow rounded-4'>
              <CardHeader className='border-0 text-center py-2'>
                <div className='mb-3'>
                  <i className='ri-check-circle-fill text-success' style={{ fontSize: 'clamp(40px, 8vw, 60px)' }}></i>
                </div>
                <CardTitle className='text-dark mb-0' style={{ fontSize: 'clamp(18px, 4vw, 24px)', fontWeight: '600' }}>
                  Registration Successful!
                </CardTitle>
              </CardHeader>
              
              <CardBody className='text-center px-4 pb-4'>
                <h5 className='mb-3 text-dark' style={{ fontWeight: '500', fontSize: 'clamp(16px, 3vw, 20px)' }}>
                  Welcome to ClickOrder
                </h5>
                <p className='text-muted mb-4' style={{ fontSize: 'clamp(14px, 2.5vw, 16px)' }}>
                  Your account has been created successfully. Download our mobile app to get started.
                </p>
                
                <div className='d-flex flex-column flex-sm-row gap-3 justify-content-center align-items-center mb-4'>
                  {/* App Store Button */}
                  <a 
                    href="https://apps.apple.com/qa/app/clickorder-io/id6736413698" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                  >
                    <Button 
                      color="dark" 
                      className="d-flex align-items-center px-4 py-3"
                      style={{ 
                        minWidth: '200px',
                        borderRadius: '8px'
                      }}
                    >
                      <div className="me-3">
                        <i className="ri-apple-fill" style={{ fontSize: 'clamp(18px, 4vw, 24px)' }}></i>
                      </div>
                      <div className="text-start">
                        <div style={{ fontSize: 'clamp(10px, 2vw, 12px)', lineHeight: '1' }}>Download on the</div>
                        <div style={{ fontSize: 'clamp(14px, 3vw, 18px)', fontWeight: 'bold' }}>App Store</div>
                      </div>
                    </Button>
                  </a>

                  {/* Google Play Button */}
                  <a 
                    href="https://play.google.com/store/apps/details?id=io.clickorder.app.consumer&hl=en&pli=1" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                  >
                    <Button 
                      color="dark" 
                      className="d-flex align-items-center px-4 py-3"
                      style={{ 
                        minWidth: '200px',
                        borderRadius: '8px'
                      }}
                    >
                      <div className="me-3">
                        <i className="ri-google-play-fill" style={{ fontSize: 'clamp(18px, 4vw, 24px)' }}></i>
                      </div>
                      <div className="text-start">
                        <div style={{ fontSize: 'clamp(10px, 2vw, 12px)', lineHeight: '1' }}>GET IT ON</div>
                        <div style={{ fontSize: 'clamp(14px, 3vw, 18px)', fontWeight: 'bold' }}>Google Play</div>
                      </div>
                    </Button>
                  </a>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
        
        {/* ClickOrder Logo at Bottom */}
        <div className='text-center mt-2'>
          <div className='d-flex justify-content-center align-items-center'>
            <img 
              src="/logo.png" 
              alt="ClickOrder Logo" 
              style={{ 
                height: '40px', 
                width: 'auto',
                maxWidth: '150px'
              }}
              className='img-fluid'
            />
          </div>
          <p className='text-white mt-2 mb-0' style={{ opacity: '0.8', fontSize: 'clamp(12px, 2vw, 14px)' }}>
            Powered by ClickOrder
          </p>
        </div>
      </div>
    </div>
  )
}

export default RegistrationSuccessful